import { render, staticRenderFns } from "./asistencia_chips.vue?vue&type=template&id=317f0c12&scoped=true&lang=pug&"
import script from "./asistencia_chips.vue?vue&type=script&lang=js&"
export * from "./asistencia_chips.vue?vue&type=script&lang=js&"
import style0 from "./asistencia_chips.vue?vue&type=style&index=0&id=317f0c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317f0c12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
